import React from "react";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/styles";

const theme = createMuiTheme(
    {
        MuiButton: {
            containedPrimary: {
                backgroundColor: '#0078d4'
            }
        },
        // direction: "rtl",
        typography: {
            fontFamily: ["Poppins"].join(",")
        },

        palette: {
            //contrastThreshold: 2,
            primary: {
                // light: will be calculated from palette.primary.main,
                main: "#0078d4"
                // dark: will be calculated from palette.primary.main,
                // contrastText: will be calculated to contrast with palette.primary.main
            },
            secondary: {
                // light: will be calculated from palette.primary.main,
                main: "#0abb87",
                // dark: will be calculated from palette.primary.main,
                contrastText: "#ffffff"
            },
            error: {
                // light: will be calculated from palette.primary.main,
                main: "#fd397a"
                // dark: will be calculated from palette.primary.main,
                // contrastText: will be calculated to contrast with palette.primary.main
            }
        },

        /**
         * @see https://material-ui.com/customization/globals/#default-props
         */
      

      
      
        props: {
            MuiButtonBase: {
                disableRipple: true,
                containedPrimary: {
                    backgroundColor: '#0078d4'
                }
            },
            MuiPopover: {
                elevation: 1
            }
        }
    }
);

export default function ThemeProvider(props) {
    const { children } = props;
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
